<template>
  <div class="PHD communities-education">
    <div class="container container-fluid">
        <h1 class="page-heading">Communities Component - Education Tab</h1>
        <div class="row ">
            <div class="col-12">
                <h2>General Cardiology</h2>
                <p class="mb-5">Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur cumque sequi, veritatis animi aspernatur, nobis perferendis, necessitatibus corporis adipisci maxime ut. Deleniti voluptatum non quisquam doloremque nemo consectetur eaque! Pariatur.</p>
            </div>
        </div>
    </div>
    <!-- CONTENT -->
   
    <!-- CONTAINER -->
    <div class="container container-fluid communities-education__wrapper">
        <!-- TIER SELECTOR - - - - - - - - - -  -->
        <div class="col-sm-12">
            <div class="row l-tier-selector">
                <div class="col-3 c-tier-selector__tabs communities-education__tabs">
                    <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                        <a class="nav-link communities-education__nav-link" @click.prevent="setActive('journals')" :class="{ active: isActive('journals') }" id="v-pills-journals-tab" data-toggle="pill" href="#v-pills-journals" role="tab" aria-controls="v-pills-journals" :aria-selected="[isActive('journals') ? true : false]">
                            <div class="nav-link__wrapper">
                                <div class="nav-link__content">
                                    <div class="heading communities-education__heading">Journals</div>
                                </div>
                            </div>
                            
                        </a>
                        <a class="nav-link communities-education__nav-link" @click.prevent="setActive('science-news')" :class="{ active: isActive('science-news') }" id="v-pills-science-news-tab" data-toggle="pill" href="#v-pills-science-news" role="tab" aria-controls="v-pills-science-news" :aria-selected="[isActive('science-news') ? true : false]">
                            <div class="nav-link__wrapper">
                                <div class="nav-link__content">
                                    <div class="heading communities-education__heading">Science News</div>
                                </div>
                            </div>
                        </a>
                        <a class="nav-link communities-education__nav-link" @click.prevent="setActive('guidelines')" :class="{ active: isActive('guidelines') }" id="v-pills-guidelines-tab" data-toggle="pill" href="#v-pills-guidelines" role="tab" aria-controls="v-pills-guidelines" :aria-selected="[isActive('guidelines') ? true : false]">
                            <div class="nav-link__wrapper">
                                <div class="nav-link__content">
                                    <div class="heading communities-education__heading">Guidelines &amp; Statements</div>
                                </div>
                            </div>
                        </a>
                        <a class="nav-link communities-education__nav-link" @click.prevent="setActive('meetings')" :class="{ active: isActive('meetings') }" id="v-pills-meetings-tab" data-toggle="pill" href="#v-pills-meetings" role="tab" aria-controls="v-pills-meetings" :aria-selected="[isActive('meetings') ? true : false]">
                            <div class="nav-link__wrapper">
                                <div class="nav-link__content">
                                    <div class="heading communities-education__heading">Meetings</div>
                                </div>
                            </div>
                        </a>
                        <a class="nav-link communities-education__nav-link" @click.prevent="setActive('education')" :class="{ active: isActive('education') }" id="v-pills-education-tab" data-toggle="pill" href="#v-pills-education" role="tab" aria-controls="v-pills-education" :aria-selected="[isActive('education') ? true : false]">
                            <div class="nav-link__wrapper">
                                <div class="nav-link__content">
                                    <div class="heading communities-education__heading">Education</div>
                                </div>
                            </div>
                        </a>
                        <a class="nav-link communities-education__nav-link" @click.prevent="setActive('council')" :class="{ active: isActive('council') }" id="v-pills-council-tab" data-toggle="pill" href="#v-pills-council" role="tab" aria-controls="v-pills-council" :aria-selected="[isActive('council') ? true : false]">
                            <div class="nav-link__wrapper">
                                <div class="nav-link__content">
                                    <div class="heading communities-education__heading">Council</div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <!-- / --------------------------------------------------------------------------------------------------------------------------------- / -->
                <div class="col-9 c-tier-selector__tab-panels">
                    <div class="tab-content communities-education__tab-content" id="v-pills-tabContent">
                        <!-- / -->
                        
                            <div class="tab-pane p-0" :class="{ 'active show': isActive('journals') }" id="v-pills-journals" role="tabpanel" aria-labelledby="v-pills-journals-tab">
                                
                                <!-- Mobile Button -->
                                <!-- Collapse Button -->
                                <button v-b-toggle="'panel-collapse-journals'" class="btn btn-link-plain btn-white btn--select" @click.prevent="setActive('journals')" :class="{ active: isActive('journals') }">
                                    <div class="nav-link__wrapper">
                                        <div class="nav-link__content">
                                            <div class="heading">Journals</div>
                                        </div>
                                    </div>
                                </button>

                                <!-- End -->
                                <!-- Collapse Content -->
                                <div class="collapse-wrapper">
                                    <b-collapse id="panel-collapse-journals" :visible="false" @hidden="onHidden">
                                        <h2 class="mt-4 mb-4">Related Journal Content</h2>
                                        <!-- 83062 - Journals Tab Content Example -->
                                        <div class="PHD__article-link-container">
                                            <a href="#" class="PHD__article-link">Comprehensive Analysis of Steroid Biomarkers for Guiding Primary Aldosteronism Subtyping</a>
                                            <span class="PHD__article-metadata">01/01/2020 | <a href="#" class="PHD__article-source-link">Hypertension</a></span>
                                        </div>

                                        <!-- 83062 - Journals Tab Content Example -->
                                        <div class="PHD__article-link-container">
                                            <a href="#" class="PHD__article-link">Comprehensive Analysis of Steroid Biomarkers for Guiding Primary Aldosteronism Subtyping</a>
                                            <span class="PHD__article-metadata">01/01/2020 | <a href="#" class="PHD__article-source-link">Hypertension</a></span>
                                        </div>

                                        <!-- 83062 - Journals Tab Content Example -->
                                        <div class="PHD__article-link-container">
                                            <a href="#" class="PHD__article-link">Comprehensive Analysis of Steroid Biomarkers for Guiding Primary Aldosteronism Subtyping</a>
                                            <span class="PHD__article-metadata">01/01/2020 | <a href="#" class="PHD__article-source-link">Hypertension</a></span>
                                        </div>

                                        <!-- 83062 - Journals Tab Content Example -->
                                        <div class="PHD__article-link-container">
                                            <a href="#" class="PHD__article-link">Comprehensive Analysis of Steroid Biomarkers for Guiding Primary Aldosteronism Subtyping</a>
                                            <span class="PHD__article-metadata">01/01/2020 | <a href="#" class="PHD__article-source-link">Hypertension</a></span>
                                        </div>

                                        <!-- 83062 - Journals Tab Content Example -->
                                        <div class="PHD__article-link-container">
                                            <a href="#" class="PHD__article-link">Comprehensive Analysis of Steroid Biomarkers for Guiding Primary Aldosteronism Subtyping</a>
                                            <span class="PHD__article-metadata">01/01/2020 | <a href="#" class="PHD__article-source-link">Hypertension</a></span>
                                        </div> 

                                        <!-- View More -->
                                        <div class="c-promo__actions c-promo__actions--divider communities-education__link">
                                            <a href="#" class="c-cta c-cta--arrow h-theme--gray-dark">View All Related Journal Content</a>
                                        </div>
                                        <!-- End View More -->
                                    </b-collapse>
                                </div>
                                <!-- End -->

                            </div>
                        <!-- / ----------------------------------------------------------------------------------------------------------------------------------------------------------------- / -->
                            <div class="tab-pane p-0" :class="{ 'show active': isActive('science-news') }" id="v-pills-science-news" role="tabpanel" aria-labelledby="v-pills-science-news-tab">
                                
                                <!-- Mobile Button -->
                                <!-- Collapse Button -->
                                <button v-b-toggle="'panel-collapse-science-news'" class="btn btn-link-plain btn-white btn--select" @click.prevent="setActive('science-news')" :class="{ active: isActive('science-news') }">
                                    <div class="nav-link__wrapper">
                                        <div class="nav-link__content">
                                            <div class="heading">Science News</div>
                                        </div>
                                    </div>
                                </button>

                                <!-- End -->
                                <!-- Collapse Content -->
                                <div class="collapse-wrapper">
                                    <b-collapse id="panel-collapse-science-news" :visible="false" @hidden="onHidden">
                                        <h2 class="mt-4 mb-4">Related Science News</h2>
                                        <!-- 83312 - Science News Tab Content Example -->
                                        <div class="PHD__article-link-container">
                                            <a href="#" class="PHD__article-link">Gender-Affirming Hormone Therapy, Vascular Health and Cardiovascular Disease in Transgender Adults</a>
                                            <span class="PHD__article-metadata"><a href="#" class="PHD__article-source-link">Circulation</a> | October 21, 2019</span>
                                        </div>

                                        <!-- 83312 - Science News Tab Content Example -->
                                        <div class="PHD__article-link-container">
                                            <a href="#" class="PHD__article-link">Gender-Affirming Hormone Therapy, Vascular Health and Cardiovascular Disease in Transgender Adults</a>
                                            <span class="PHD__article-metadata"><a href="#" class="PHD__article-source-link">Circulation</a> | October 21, 2019</span>
                                        </div>

                                        <!-- 83312 - Science News Tab Content Example -->
                                        <div class="PHD__article-link-container">
                                            <a href="#" class="PHD__article-link">Gender-Affirming Hormone Therapy, Vascular Health and Cardiovascular Disease in Transgender Adults</a>
                                            <span class="PHD__article-metadata"><a href="#" class="PHD__article-source-link">Circulation</a> | October 21, 2019</span>
                                        </div>

                                        <!-- 83312 - Science News Tab Content Example -->
                                        <div class="PHD__article-link-container">
                                            <a href="#" class="PHD__article-link">Gender-Affirming Hormone Therapy, Vascular Health and Cardiovascular Disease in Transgender Adults</a>
                                            <span class="PHD__article-metadata"><a href="#" class="PHD__article-source-link">Circulation</a> | October 21, 2019</span>
                                        </div>

                                        <!-- 83312 - Science News Tab Content Example -->
                                        <div class="PHD__article-link-container">
                                            <a href="#" class="PHD__article-link">Gender-Affirming Hormone Therapy, Vascular Health and Cardiovascular Disease in Transgender Adults</a>
                                            <span class="PHD__article-metadata"><a href="#" class="PHD__article-source-link">Circulation</a> | October 21, 2019</span>
                                        </div>

                                        <!-- 83312 - Science News Tab Content Example -->
                                        <div class="PHD__article-link-container">
                                            <a href="#" class="PHD__article-link">Gender-Affirming Hormone Therapy, Vascular Health and Cardiovascular Disease in Transgender Adults</a>
                                            <span class="PHD__article-metadata"><a href="#" class="PHD__article-source-link">Circulation</a> | October 21, 2019</span>
                                        </div>

                                        <!-- View More -->
                                        <div class="c-promo__actions c-promo__actions--divider communities-education__link">
                                            <a href="#" class="c-cta c-cta--arrow h-theme--gray-dark">View More Science News</a>
                                        </div>
                                        <!-- End View More -->
                                    </b-collapse>
                                </div>
                                <!-- End -->

                            </div>
                        <!-- / ----------------------------------------------------------------------------------------------------------------------------------------------------------------- / -->
                            <div class="tab-pane p-0" :class="{ 'show active': isActive('guidelines') }" id="v-pills-guidelines" role="tabpanel" aria-labelledby="v-pills-guidelines-tab">
                                
                                <!-- Mobile Button -->
                                <!-- Collapse Button -->
                                <button v-b-toggle="'panel-collapse-guidelines'" class="btn btn-link-plain btn-white btn--select" @click.prevent="setActive('guidelines')" :class="{ active: isActive('guidelines') }">
                                    <div class="nav-link__wrapper">
                                        <div class="nav-link__content">
                                            <div class="heading">Guidelines &amp; Statements</div>
                                        </div>
                                    </div>
                                </button>

                                <!-- End -->
                                <!-- Collapse Content -->
                                <div class="collapse-wrapper">
                                    <b-collapse id="panel-collapse-guidelines" :visible="false" @hidden="onHidden">
                                        <h2 class="mt-4 mb-4">Related Guidelines &amp; Statements</h2>
                                        <!-- 83313 - Guidelines & Statements Tab Content Example -->
                                        <div class="PHD__article-link-container">
                                            <a href="#" class="PHD__article-link">2019 AHA/ACC Clinical Performance and Quality Measures for Adults With High Blood Pressure: A Report of the American College of Cardiology/American Heart Association Task Force on Performance Measures</a>
                                            <span class="PHD__article-metadata">Published Nov 2019</span>
                                        </div>

                                        <!-- 83313 - Guidelines & Statements Tab Content Example -->
                                        <div class="PHD__article-link-container">
                                            <a href="#" class="PHD__article-link">2019 AHA/ACC Clinical Performance and Quality Measures for Adults With High Blood Pressure: A Report of the American College of Cardiology/American Heart Association Task Force on Performance Measures</a>
                                            <span class="PHD__article-metadata">Published Nov 2019</span>
                                        </div>

                                        <!-- 83313 - Guidelines & Statements Tab Content Example -->
                                        <div class="PHD__article-link-container">
                                            <a href="#" class="PHD__article-link">2019 AHA/ACC Clinical Performance and Quality Measures for Adults With High Blood Pressure: A Report of the American College of Cardiology/American Heart Association Task Force on Performance Measures</a>
                                            <span class="PHD__article-metadata">Published Nov 2019</span>
                                        </div>

                                        <!-- 83313 - Guidelines & Statements Tab Content Example -->
                                        <div class="PHD__article-link-container">
                                            <a href="#" class="PHD__article-link">2019 AHA/ACC Clinical Performance and Quality Measures for Adults With High Blood Pressure: A Report of the American College of Cardiology/American Heart Association Task Force on Performance Measures</a>
                                            <span class="PHD__article-metadata">Published Nov 2019</span>
                                        </div>

                                        <!-- 83313 - Guidelines & Statements Tab Content Example -->
                                        <div class="PHD__article-link-container">
                                            <a href="#" class="PHD__article-link">2019 AHA/ACC Clinical Performance and Quality Measures for Adults With High Blood Pressure: A Report of the American College of Cardiology/American Heart Association Task Force on Performance Measures</a>
                                            <span class="PHD__article-metadata">Published Nov 2019</span>
                                        </div>

                                        <!-- View More -->
                                        <div class="c-promo__actions c-promo__actions--divider communities-education__link">
                                            <a href="#" class="c-cta c-cta--arrow h-theme--gray-dark">View All Guidelines &amp; Statements</a>
                                        </div>
                                        <!-- End View More -->
                                    </b-collapse>
                                </div>
                                <!-- End -->

                            </div>
                        <!-- / ----------------------------------------------------------------------------------------------------------------------------------------------------------------- / -->
                            <div class="tab-pane p-0" :class="{ 'show active': isActive('meetings') }" id="v-pills-meetings" role="tabpanel" aria-labelledby="v-pills-meetings-tab">
                                
                                <!-- Mobile Button -->
                                <!-- Collapse Button -->
                                <button v-b-toggle="'panel-collapse-meetings'" class="btn btn-link-plain btn-white btn--select" @click.prevent="setActive('meetings')" :class="{ active: isActive('meetings') }">
                                    <div class="nav-link__wrapper">
                                        <div class="nav-link__content">
                                            <div class="heading">Meetings</div>
                                        </div>
                                    </div>
                                </button>

                                <!-- End -->
                                <!-- Collapse Content -->
                                <div class="collapse-wrapper">
                                    <b-collapse id="panel-collapse-meetings" :visible="false" @hidden="onHidden">
                                        <h2 class="mt-4 mb-4">Related Meetings</h2>
                                        <!-- Begin PHD Meeting -->
                                        <div class="c-phd-meeting">
                                            <div class="container">
                                                <div class="row">
                                                    <div class="col-12 col-lg-6 c-phd-meeting__image-container">
                                                        <div class="h-placeholder-image h-placeholder-image--4-3">
                                                            <img src="assets/images/placeholder.gif" alt="alt text">
                                                            <span class="c-phd-meeting__image-title">Featured Session</span>
                                                        </div>
                                                    </div>

                                                    <div class="col-12 col-lg-6 c-phd-meeting__metadata-container">
                                                        <h3>International Stroke Conference</h3>
                                                        <p class="date">Precon & Nursing: Feb. 18 | Sessions: Feb. 19–21, 2020</p>
                                                        <p class="location">Los Angeles, Calif.</p>
                                                        <hr>
                                                        <p class="c-phd-meeting__registration c-phd-meeting__registration--status">Registration now open</p>
                                                        <p class="c-phd-meeting__registration c-phd-meeting__registration--message">Get EARLY pricing through Dec. 31!</p>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <!-- Dev Notes: Content can be dropped into this div with class 'c-phd-meeting__content-container' -->
                                                    <div class="col-12 order-2 order-md-1 c-phd-meeting__content-container">
                                                        <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nemo eveniet exercitationem esse architecto consequatur consequuntur sapiente, modi accusamus amet porro deserunt perferendis soluta sunt quisquam autem dolorem dolore! Vitae, natus.</p>
                                                        <ul>
                                                            <li>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ad ut nisi quia assumenda, voluptas incidunt quasi dolor. Neque, corporis a dolorum facilis facere qui quidem expedita ex id, aliquid exercitationem?</li>
                                                            <li>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Doloribus laboriosam culpa vitae! Optio possimus perspiciatis accusamus laborum odio quisquam reprehenderit vitae maiores quas est. Beatae incidunt blanditiis sit ut distinctio.</li>
                                                        </ul>
                                                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Fuga, labore aperiam. Minus hic ipsa ullam, consequatur doloribus rem distinctio aut adipisci facere! Fugiat, consequatur accusantium necessitatibus fuga sit consequuntur iste.</p>
                                                    </div>

                                                    <!-- Dev Notes: Following requirements, front end styles allow for 0 to 4 links -->
                                                    <ul class="col-12 order-1 order-lg-2 c-phd-meeting__buttons-list">
                                                        <li class="c-phd-meeting__buttons-list-item"><a href="#" class="btn btn-outline">Housing &amp; Transportation</a></li>
                                                        <li class="c-phd-meeting__buttons-list-item"><a href="#" class="btn btn-outline">Submit Abstract</a></li>
                                                        <li class="c-phd-meeting__buttons-list-item"><a href="#" class="btn btn-outline">View Programming</a></li>
                                                        <!-- Dev Notes: An anchor element WITHOUT the 'btn-outline' class will be a red button -->
                                                        <li class="c-phd-meeting__buttons-list-item"><a href="#" class="btn">Register Now</a></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- End PHD Meeting -->
                                        <!-- View More -->
                                        <div class="c-promo__actions c-promo__actions--divider communities-education__link">
                                            <a href="#" class="c-cta c-cta--arrow h-theme--gray-dark">View All Meetings</a>
                                        </div>
                                        <!-- End View More -->
                                    </b-collapse>
                                </div>
                                <!-- End -->
                            </div>
                        <!-- / ----------------------------------------------------------------------------------------------------------------------------------------------------------------- / -->
                            <div class="tab-pane p-0" :class="{ 'show active': isActive('education') }" id="v-pills-education" role="tabpanel" aria-labelledby="v-pills-education-tab">
                                
                                <!-- Mobile Button -->
                                <!-- Collapse Button -->
                                <button v-b-toggle="'panel-collapse-education'" class="btn btn-link-plain btn-white btn--select" @click.prevent="setActive('education')" :class="{ active: isActive('education') }">
                                    <div class="nav-link__wrapper">
                                        <div class="nav-link__content">
                                            <div class="heading">Education</div>
                                        </div>
                                    </div>
                                </button>

                                <!-- End -->
                                <!-- Collapse Content -->
                                <div class="collapse-wrapper">
                                    <b-collapse id="panel-collapse-education" :visible="false" @hidden="onHidden">
                                        <!-- Dev Notes: 
                                            This H2 should be exactly as appears, on the back-end, with Sitecore content filling it out.
                                        -->
                                        <h2 class="mt-4 mb-4">Continuing Education</h2>

                                        <!-- Begin: Education Activities List -->
                                        <phd-education-activities-list :numbertoshow="3"></phd-education-activities-list>
                                        <!-- End:   Education Activities List -->

                                        <!-- Dev Notes: 
                                            This link should be exactly as appears, on the back-end, with Sitecore content filling out the href and text.
                                        -->
                                        <!-- View More -->
                                        <div class="c-promo__actions c-promo__actions--divider communities-education__link">
                                            <a href="#" class="c-cta c-cta--arrow h-theme--gray-dark">View More Education on Life Long Learning</a>
                                        </div>
                                        <!-- End View More -->
                                    </b-collapse>
                                </div>
                                <!-- End -->

                            </div>
                        <!-- / ----------------------------------------------------------------------------------------------------------------------------------------------------------------- / -->
                            <div class="tab-pane p-0" :class="{ 'show active': isActive('council') }" id="v-pills-council" role="tabpanel" aria-labelledby="v-pills-council-tab">
                                
                                <!-- Mobile Button -->
                                <!-- Collapse Button -->
                                <button v-b-toggle="'panel-collapse-council'" class="btn btn-link-plain btn-white btn--select" @click.prevent="setActive('council')" :class="{ active: isActive('council') }">
                                    <div class="nav-link__wrapper">
                                        <div class="nav-link__content">
                                            <div class="heading">Council</div>
                                        </div>
                                    </div>
                                </button>

                                <!-- End -->
                                <!-- Collapse Content -->
                                <div class="collapse-wrapper">
                                    <b-collapse id="panel-collapse-council" :visible="false" @hidden="onHidden">
                                        <h2 class="mt-4 mb-4">Related Scientific Councils</h2>
                                        <div class="c-phd-card">
                                            <div class="c-phd-card__background h-placeholder-image h-placeholder-image--4-3">
                                                <!-- Don't use this anymore, Sitecore experience editor can't use the v-lazy-img prop -->
                                                <!-- <img src="assets/images/placeholder.gif" alt="alt text" v-lazy-img="'//placehold.it/750x563/ddd/ccc?text=FPO'"/> -->
                                                <!-- Alernative, add class is-loaded -->
                                                <img src="//placehold.it/750x563/ddd/ccc?text=FPO" alt="alt text" class="is-loaded" />
                                            </div>

                                            <div class="c-phd-card__content">
                                                <h3 class="c-phd-card__heading">Cardiovascular and Stroke Nursing (CVSN)</h3>

                                                <p slot="content">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam interdum maximus turpis, nec malesuada augue interdum at. Ut sed elit mollis, sollicitudin nisi sed, congue diam. </p>

                                                <hr>

                                                <div class="c-phd-card__actions">
                                                    <div class="c-phd-card__action">
                                                        <a href="#" class="c-cta c-cta--arrow">Scientific Sessions</a>
                                                    </div>

                                                    <div class="c-phd-card__action">
                                                        <a href="#" class="c-cta c-cta--arrow">Resuscitation Science Symposium</a>
                                                    </div>

                                                    <div class="c-phd-card__action">
                                                        <a href="#" class="c-cta c-cta--arrow">CVRI Council Awards</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="c-phd-card">
                                            <div class="c-phd-card__background h-placeholder-image h-placeholder-image--4-3">
                                                <!-- Don't use this anymore, Sitecore experience editor can't use the v-lazy-img prop -->
                                                <!-- <img src="assets/images/placeholder.gif" alt="alt text" v-lazy-img="'//placehold.it/750x563/ddd/ccc?text=FPO'"/> -->
                                                <!-- Alernative, add class is-loaded -->
                                                <img src="//placehold.it/750x563/ddd/ccc?text=FPO" alt="alt text" class="is-loaded" />
                                            </div>

                                            <div class="c-phd-card__content">
                                                <h3 class="c-phd-card__heading">Cardiovascular and Stroke Nursing (CVSN)</h3>

                                                <p slot="content">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam interdum maximus turpis, nec malesuada augue interdum at. Ut sed elit mollis, sollicitudin nisi sed, congue diam. </p>

                                                <hr>

                                                <div class="c-phd-card__actions">
                                                    <div class="c-phd-card__action">
                                                        <a href="#" class="c-cta c-cta--arrow">Scientific Sessions</a>
                                                    </div>

                                                    <div class="c-phd-card__action">
                                                        <a href="#" class="c-cta c-cta--arrow">Resuscitation Science Symposium</a>
                                                    </div>

                                                    <div class="c-phd-card__action">
                                                        <a href="#" class="c-cta c-cta--arrow">CVRI Council Awards</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- View More -->
                                     
                                        <!-- End View More -->
                                    </b-collapse>
                                </div>
                                <!-- End -->

                            </div>
                        <!-- / -->

                    </div>
                </div>
            </div>
        </div>
        <!-- END TIER SELECTOR - - - - - - - -  -->
    </div>
    <!-- END CONTAINER -->

    <!-- end -->
  </div>
</template>

<script>
import idMixin from '@/mixins/aha-id';
export default {
    name: 'selector',
    mixins: [ idMixin ],
    data() {
        return {
            activeItem: 'journals',
            tierId: null,
            mobile: window.innerWidth <= 700

        }
    },
    created() {
       if(this.mobile) {
           this.activeItem = ' ';
       }
    },
    methods: {
        isActive (menuItem) {
            return this.activeItem === menuItem
        },
        setActive (menuItem) {
            this.activeItem = menuItem;
            if(this.activeItem === 'guidelines') {
                console.log('guidelines')
            }
        },
        onHidden() {
            console.log("closed");
            this.activeItem = ''
        }
    },
    mounted() {
        this.tierId = this.safeId('__PHD_selector_');
        console.log(this.tierId)
    }
}
</script>



// WEBPACK FOOTER //
// src/app/components/phd/communities-education.vue